<template>
  <ul class="list-of-member-products">
    <li
      v-for="memberOfMasterId in computedMemberProducts"
      :key="memberOfMasterId"
      class="member-product-item"
    >
      <GiftMemberProduct
        v-if="isGiftWithPurchase"
        :product-id="memberOfMasterId"
      />
      <MemberProduct
        v-else
        :product-id="memberOfMasterId"
      />
    </li>
  </ul>

  <button
    v-if="shouldShowMoreButton"
    class="show-more-members secondary button expanded small-margin-bottom-xl medium-margin-bottom-xxl margin-top-m"
    @click="showMoreMemberProducts"
  >
    Show {{ moreItemsCount }} More Items
  </button>
</template>

<script setup>
import {
  ref, computed, watchEffect,
} from 'vue';
import MemberProduct from '@components/ProductCard/MemberProduct';
import GiftMemberProduct from '@components/ProductCard/GiftMemberProduct';
import { useProductType } from '@composables/useProductType';

const MEMBER_PRODUCTS_VISIBLE_AMOUNT = 10;

const props = defineProps({
  list: {
    /** @type import('vue').PropType<ProductId[]> */
    type: Array,
    required: true,
    /** @param {ProductId[]} value */
    validator(value) {
      return Array.isArray(value) && value.length > 0;
    },
  },
});

const {
  isGiftWithPurchase,
} = useProductType();

const computedMemberProducts = ref(props.list?.slice(0, MEMBER_PRODUCTS_VISIBLE_AMOUNT));
const shouldShowMoreButton = computed(() => props.list?.length > computedMemberProducts.value?.length);
const moreItemsCount = computed(() => props.list?.length - computedMemberProducts.value?.length);
const showMoreMemberProducts = () => {
  computedMemberProducts.value = props.list;
};

watchEffect(() => {
  computedMemberProducts.value = props.list?.slice(0, MEMBER_PRODUCTS_VISIBLE_AMOUNT);
});
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
.button.expanded.show-more-members {
  display: block;
  margin: auto;
}

.member-product-item {
  border-bottom: 1px solid $gray-3-color;

  &:not(:first-child) {
    @include breakpoint(small only) {
      @include margin-top-xl;
    }
    @include margin-top-m;
  }
}

.list-of-member-products {
  list-style: none;
  margin: 0;
  padding: 0;
}
@include breakpoint(medium up) {
  .show-more-members {
    max-width: 335px;
  }
}
</style>
